import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Flame, Send, BellRing } from "lucide-react";
import { api, formatErr } from "@/lib/api";
import { QuestGoals } from "@/components/quest/QuestGoals";
import { QuestNewForm } from "@/components/quest/QuestNewForm";
import { QuestGoalsEdit } from "@/components/quest/QuestGoalsEdit";
import { QuestEndEdit } from "@/components/quest/QuestEndEdit";

export function QuestAdmin() {
  const [q, setQ] = useState(null);
  const load = useCallback(() => api.get("/admin/quest").then(({ data }) => setQ(data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  if (!q) return null;
  const send = async (push, popup) => {
    try {
      const { data } = await api.post("/admin/quest/announce", { push, popup });
      toast.success([push && `Push an ${data.sent} Geräte`, popup && "Popup für alle"].filter(Boolean).join(" + ") + " gesendet");
      load();
    } catch (e) { toast.error(formatErr(e)); }
  };
  return (
    <div className="space-y-4" data-testid="admin-quest">
      <div className="quest-glow rounded-3xl text-white p-5 space-y-3">
        <p className="font-display text-xl font-extrabold flex items-center gap-2"><Flame className="w-5 h-5" /> Community-Aufgabe</p>
        <p className="text-sm text-red-50">Bis {new Date(q.end).toLocaleString("de-DE", { timeZone: "Europe/Berlin", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })} Uhr · {q.participants} Mitmacher · Einsatz ±{q.stake} Punkte · Status: <b data-testid="admin-quest-status">{q.status === "running" ? "läuft" : q.status === "ended" ? "wird ausgewertet" : q.success ? "geschafft" : "verpasst"}</b></p>
        <QuestGoals goals={q.goals} />
      </div>
      {q.status === "running" && (
        <div className="rounded-2xl border border-red-100 bg-red-50/50 p-4 space-y-3">
          <p className="text-sm font-bold">Zwischenstand an alle senden</p>
          <p className="text-xs text-slate-500 rounded-xl bg-white border border-red-100 p-3" data-testid="admin-quest-text">{q.status_text}</p>
          <div className="flex flex-wrap gap-2">
            <button onClick={() => send(true, false)} data-testid="admin-quest-push" className="h-10 px-4 rounded-full bg-[#d2042d] text-white text-sm font-bold inline-flex items-center gap-1.5"><Send className="w-4 h-4" /> Per Push</button>
            <button onClick={() => send(false, true)} data-testid="admin-quest-popup" className="h-10 px-4 rounded-full bg-white border border-[#d2042d] text-[#d2042d] text-sm font-bold inline-flex items-center gap-1.5"><BellRing className="w-4 h-4" /> Als Popup</button>
            <button onClick={() => send(true, true)} data-testid="admin-quest-both" className="h-10 px-4 rounded-full pink-gradient text-white text-sm font-bold">Push + Popup</button>
          </div>
          <p className="text-xs text-slate-400">Das Popup erscheint bei allen beim nächsten Öffnen bzw. innerhalb einer Minute, mit Live-Fortschritt und Restzeit.</p>
        </div>
      )}
      {q.status === "running" && <QuestEndEdit key={q.end} q={q} onDone={load} />}
      {q.status === "running" && <QuestGoalsEdit key={q.goals.map((g) => g.kind + g.goal).join()} q={q} onDone={load} />}
      {q.status !== "running" && <QuestNewForm onDone={load} />}
    </div>
  );
}
